import { render } from "./FilterSettingsComponent.vue?vue&type=template&id=2b3ad203"
import script from "./FilterSettingsComponent.vue?vue&type=script&lang=js"
export * from "./FilterSettingsComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vincent/Herd/app.prixo.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__